import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  inStock: {
    id: 'product.item.in.stock',
    defaultMessage: 'skladem',
  },
  voucherDescriptionText: {
    id: 'product.item.voucher.description.text',
    defaultMessage: 's kódem {code}',
  },
  discountAmount: {
    id: 'product.item.discount.highlighted',
    defaultMessage: '-{amount} %',
  },
  notAvailableText: {
    id: 'product.item.unavailable.label',
    defaultMessage: 'Nedostupné',
  },
  disabledProductText: {
    id: 'product.item.disabled.label',
    defaultMessage: 'Prodej byl ukončen',
  },
  sponsored: {
    id: 'productCard.label.sponsored',
  },
  sponsoredTooltip: {
    id: 'productCard.label.sponsored.tooltip',
    defaultMessage:
      'Tento produkt doporučuje a sponzoruje náš obchodní partner.',
  },
});
